import { Ref, RefObject } from 'react';

import { gsap } from '@/lib/gsap';

export const TILT_CARD_DESKTOP_MQ = '(min-width: 992px)';

export const assignRef = <T>(ref: Ref<T> | undefined, node: T | null) => {
	if (!ref) return;
	if (typeof ref === 'function') ref(node);
	else (ref as RefObject<T | null>).current = node;
};

export const runIconDrift = (el: HTMLImageElement) => {
	gsap.killTweensOf(el);
	gsap.to(el, {
		x: () => gsap.utils.random(-8, 8),
		y: () => gsap.utils.random(-8, 8),
		z: 30,
		rotate: () => gsap.utils.random(-12, 12),
		duration: () => gsap.utils.random(2.5, 4),
		ease: 'sine.inOut',
		repeat: -1,
		yoyo: true
	});
};

export const stopIconDrift = (iconRef: RefObject<HTMLImageElement | null>) => {
	const el = iconRef.current;
	if (!el) return;
	gsap.killTweensOf(el);
	gsap.set(el, { x: 0, y: 0, z: 0, rotate: 0 });
};

export const startIconDriftIfAllowed = (
	iconRef: RefObject<HTMLImageElement | null>,
	isCardInViewRef: RefObject<boolean>
) => {
	const el = iconRef.current;
	if (!el || !isCardInViewRef.current) return;
	if (typeof window !== 'undefined' && !window.matchMedia(TILT_CARD_DESKTOP_MQ).matches) return;
	runIconDrift(el);
};
